
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { palette } from '@/utils/palette'

@Component<TextBadge>({})
export default class TextBadge extends Vue {
    @Prop({ type: String, required: false }) private text!: string // Can use text or <slot />
    @Prop({ type: String, default: palette.purpleLight })
    private backgroundColour!: string // CSS colour string
    @Prop({ type: String, default: palette.black }) private textColour!: string // CSS colour string
}
